<template>
  <svg
    width="169"
    height="20"
    viewBox="0 0 169 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5526_6521)">
      <path
        d="M0 9.97895C0 5.14527 2.90526 1.36421 8.05895 1.36421C11.7642 1.36421 14.3158 3.26737 15.4947 6.54316L13.0442 8.34526C12.5221 5.81895 10.9642 4.04211 8.09263 4.04211C4.64 4.04211 3.01474 6.49263 3.01474 9.97053C3.01474 13.4484 4.64 15.8989 8.09263 15.8989C10.9726 15.8989 12.5221 14.0968 13.0442 11.5958L15.4947 13.3979C14.3158 16.6484 11.7642 18.5768 8.05895 18.5768C2.90526 18.5853 0 14.8042 0 9.97895Z"
        fill="white"
      />
      <path
        d="M16.9375 18.3832L23.4975 1.61684H26.748L33.308 18.3832H30.2007L28.6007 14.1558H21.5186L19.9186 18.3832H16.9375ZM22.4449 11.7053H27.6743L25.9733 7.17474L25.0722 4.14316L24.1712 7.17474L22.4449 11.7053Z"
        fill="white"
      />
      <path
        d="M35.0312 14.6526L37.0355 12.6232C37.9365 15.0737 40.4628 16.0253 42.5176 16.0253C44.1934 16.0253 45.5491 15.4274 45.5491 13.8947C45.5491 12.2695 44.2018 11.8147 42.0207 11.3432L40.446 10.9895C38.0713 10.4926 35.5449 9.41474 35.5449 6.23158C35.5449 3.04843 38.2734 1.38106 41.4228 1.38106C44.5723 1.38106 46.9555 2.66106 48.1513 4.96001L46.0207 6.98948C45.0944 4.90948 43.2923 4.00843 41.2376 4.00843C39.6376 4.00843 38.4839 4.7579 38.4839 6.0379C38.4839 7.51158 39.6376 8.04211 41.4649 8.48843L43.3428 8.94316C46.0207 9.59158 48.4207 10.6442 48.4207 13.8442C48.4207 16.8758 45.8691 18.6274 42.467 18.6274C39.267 18.6274 36.3365 17.4737 35.0312 14.6526Z"
        fill="white"
      />
      <path
        d="M52.2188 18.3832V1.61684H64.084V4.1179H55.0482V8.57263H62.5261V11.0737H55.0482V15.8821H64.084V18.3832H52.2188Z"
        fill="white"
      />
      <path
        d="M104.086 9.97895C104.086 5.14527 106.991 1.37263 112.145 1.37263C115.85 1.37263 118.402 3.27579 119.581 6.55158L117.13 8.35369C116.608 5.82737 115.05 4.05053 112.179 4.05053C108.726 4.05053 107.101 6.50106 107.101 9.97895C107.101 13.4568 108.726 15.9074 112.179 15.9074C115.059 15.9074 116.608 14.1053 117.13 11.6042L119.581 13.4063C118.402 16.6568 115.85 18.5853 112.145 18.5853C106.991 18.5853 104.086 14.8042 104.086 9.97895Z"
        fill="white"
      />
      <path
        d="M123.078 18.3832V1.61684H125.908V15.8821H134.489V18.3832H123.078Z"
        fill="white"
      />
      <path
        d="M136.961 11.2253V1.61684H139.765V11.2505C139.765 14.5768 140.894 15.9326 143.647 15.9326C146.401 15.9326 147.529 14.5853 147.529 11.2505V1.61684H150.334V11.2253C150.334 16.3032 148.203 18.6358 143.63 18.6358C139.058 18.6358 136.978 16.3116 136.978 11.2253H136.961Z"
        fill="white"
      />
      <path
        d="M155.125 18.3832V1.61684H162.729C166.131 1.61684 167.731 3.41895 167.731 5.89474C167.731 8.1179 165.98 9.44842 163.277 9.67579C167.083 9.97895 168.43 11.68 168.43 13.9284C168.43 16.9095 166.207 18.3832 162.603 18.3832H155.125ZM157.954 4.1179V8.5979H161.98C163.656 8.5979 164.809 8.07579 164.809 6.37474C164.809 4.67369 163.63 4.12632 161.879 4.12632H157.946L157.954 4.1179ZM157.954 10.9726V15.8737H162.182C164.481 15.8737 165.533 15.1242 165.533 13.4232C165.533 11.7221 164.203 10.9726 162.258 10.9726H157.954Z"
        fill="white"
      />
      <path
        d="M90.7717 2.63579V1.61684H77.3906V2.63579L84.0854 9.33053L90.7717 2.63579Z"
        fill="white"
      />
      <path
        d="M77.3906 17.3895V18.4084H90.7717V17.3895L84.0854 10.6947L77.3906 17.3895Z"
        fill="white"
      />
      <path
        d="M76.7064 3.32632H75.6875V16.6821H76.7317L83.3928 10.0126L76.7064 3.32632Z"
        fill="white"
      />
      <path
        d="M92.4709 3.32632H91.4519L84.7656 10.0126L91.4351 16.6821H92.4709V3.32632Z"
        fill="white"
      />
      <path d="M76.6213 0H74.0781V2.54316H76.6213V0Z" fill="white" />
      <path d="M94.0744 0H91.5312V2.54316H94.0744V0Z" fill="white" />
      <path d="M76.6213 17.4568H74.0781V20H76.6213V17.4568Z" fill="white" />
      <path d="M94.0744 17.4568H91.5312V20H94.0744V17.4568Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_5526_6521">
        <rect width="168.438" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
